module.exports = __webpack_public_path__ + "media/images/close_x-d4cc40a348b79c3ba8ee78bbb6f90b1e.png";